import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Layout, Menu, Avatar, Button, Drawer, Breadcrumb, Row, Col } from 'antd';
import { UserOutlined, MenuOutlined, DollarOutlined, FunnelPlotOutlined, WechatOutlined, PlusCircleOutlined, CoffeeOutlined, BarChartOutlined, CreditCardOutlined, PoweroffOutlined, ProfileOutlined, CaretRightOutlined, SettingOutlined, MessageOutlined } from '@ant-design/icons';
import useWindowDimensions from '../../hooks/windowDimensionsHook'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { connect } from 'react-redux'
import evconnectlogo from '../../imagens/logo.jpg'
import evconnectlogoFooter from '../../imagens/evconnectb.png'

const { SubMenu } = Menu;
const { Header, Content, Footer } = Layout;
const LayoutDetail = ({ tabsFiliais, LimparTabs, usuario, definirUsuario, children, breadCrumbs = [] }) => {

  let history = useHistory();
  const { height, width } = useWindowDimensions();
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const [userDetail, setUser] = useState(location.state !== undefined ? location.state.detail : Sair());
  async function usuarioLocal() {
    try {
      const jsonValue = await AsyncStorage.getItem('user');
      console.log('Verificando se existe usuario', jsonValue)
      if (jsonValue != null) {
        setUser(JSON.parse(jsonValue))
      } else {
        history.push({
          pathname: '/',
        });
      }
    } catch (e) {
      history.push({
        pathname: '/',
      });
    }
  }
  const [Nome, setNome] = useState(userDetail.nome.split(" ")[0]);
  const [Perfil, setPerfil] = useState(userDetail.perfil);


  const navegarPara = (path) => {
    history.push({
      pathname: path,
      state: { detail: userDetail }
    });
  }

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  async function Sair() {

    definirUsuario(undefined);
    LimparTabs([]);
    await AsyncStorage.removeItem('user');
    history.push({
      pathname: '/',
    });
  };
  return (

    <Layout>
      <Header className="header">
        <Row>

          {
            width > 600 ? (
              <>
                {width > 600 ? (
                  <Col span={1}>
                    <Button type="link" style={{ color: '#fff' }} onClick={showDrawer} icon={<MenuOutlined />}>

                    </Button>
                  </Col>
                ) : null
                }

                <Col span={1}>
                  <img width={width > 600 ? 62 : 32} src={evconnectlogo} />
                </Col>
                {width > 600 ? (
                  <Col style={{padding:15}} span={20}>

                    <Breadcrumb separator={<CaretRightOutlined style={{ fontSize: 15, color: '#fff' }} />} style={{ margin: '5px', color: '#fff' }}>
                      <Breadcrumb.Item style={{ padding: 3, backgroundColor: '#052e4d', color: '#fff' }}>{userDetail.perfil} </Breadcrumb.Item>
                      {
                        breadCrumbs.map(function (item) {
                          if (item === breadCrumbs[breadCrumbs.length - 1]) {
                            return <Breadcrumb.Item style={{ padding: 5, border: '1px solid #135080', backgroundColor: '#135080', color: '#fff' }}> {item} </Breadcrumb.Item>
                          } else {
                            return <Breadcrumb.Item style={{ padding: 5, border: '1px solid #135080', color: '#fff' }}> {item} </Breadcrumb.Item>
                          }
                        })
                      }
                    </Breadcrumb>

                  </Col>
                ) : <Col span={4}></Col>
                }
                <Col span={1}>
                  <Row>
                    <Col style={{ padding: 5 }}><WechatOutlined style={{ color: '#fff' }} /></Col>
                  </Row>
                </Col>
              </>
            ) : (
                <>
                  <Col span={20}>
                    <img width={150} src={evconnectlogo} />
                  </Col>
                  <Col span={4}>
                    <Row>
                      <Col>
                        <Button icon={<MenuOutlined />} type="primary" onClick={showDrawer}>
                          Menu
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </>
              )
          }
        </Row>
      </Header>
     
      <Content style={{ padding: '0 50px' }}>
        <Layout className="site-layout-background" style={{ padding: width > 600 ? '0' : '10px 0' }}>
          <Drawer
            title="Seus serviços"
            placement="left"
            bodyStyle={{ backgroundColor: '#fff' }}
            closable={false}
            onClose={onClose}
            visible={visible} >
            <Row>
              <Col style={{ textAlign: 'center' }} span={24}>
                <Avatar size={44} icon={<UserOutlined />} />
                <Row>
                  <Col span={24} style={{ padding: 5, color: '#333', textAlign: 'center' }}>{Nome}</Col>
                </Row>
                <Row>
                  <Col>
                    <Menu
                      style={{ flex: 1 }}
                      defaultSelectedKeys={['1']}
                      defaultOpenKeys={['perfil', 'fiscal', 'checkout']}
                      mode="inline">
                      {userDetail.perfil === 'Admin' ? (
                        <SubMenu key="perfil" icon={<CoffeeOutlined />} title={Perfil}>
                          <Menu.Item icon={<BarChartOutlined />} key="1"><a onClick={() => navegarPara('/dashboard')}>Dashboard</a></Menu.Item>
                          <Menu.Item icon={<SettingOutlined />} key="2"><a onClick={() => navegarPara('/configuracao')}>Configurações</a></Menu.Item>

                        </SubMenu>
                      ) : null}
                      <SubMenu key="fiscal" icon={<DollarOutlined />} title="Fiscal">
                        <Menu.Item icon={<FunnelPlotOutlined />} key="3"><a onClick={() => navegarPara('/nfs')}>Notas</a></Menu.Item>
                        <Menu.Item icon={<PlusCircleOutlined />} key="4"><a onClick={() => navegarPara('/cadastrar')}>Cadastro</a> </Menu.Item>
                      </SubMenu>
                      <SubMenu key="checkout" icon={<CreditCardOutlined />} title="Checkout">
                        <Menu.Item icon={<FunnelPlotOutlined />} key="5"><a onClick={() => navegarPara('/checkout')}>Pagamentos</a></Menu.Item>
                        <Menu.Item icon={<PlusCircleOutlined />} key="6"><a onClick={() => navegarPara('/checkout/cadastrar')}>Cadastrar Pagamento</a></Menu.Item>
                      </SubMenu>
                      <SubMenu key="checkout" title="Outros">
                        <Menu.Item icon={<PoweroffOutlined />} key="7"><a onClick={Sair}>Sair</a></Menu.Item>
                      </SubMenu>
                    </Menu>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Drawer>
          <Row>
            <Col style={{ minHeight: height - 160, padding: 20 }} span={24}>
              <Content style={{ minHeight: 280, backgroundColor: '#eee' }} >{children}</Content>
            </Col>
          </Row>
        </Layout>
      </Content>
      <Footer style={{ textAlign: 'center', float: 'left', height: 100, backgroundColor: '#135080' }}>
        <Row>
        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
          <img width={150} src={evconnectlogoFooter} />
          </Col>
          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            <Row>
              <h3 style={{ color: '#fff' }}>TIC Evidence</h3>
            </Row>
            <Row>
              <p style={{ color: '#fff' }}>Evidnce © - Grupo Evidence 2001. -Rua Padre Valdevino, 1905. Fortaleza – CE – 60135-041</p>
            </Row>
          </Col>
          <Col xs={24} sm={24} md={4} lg={4} xl={4}>
            <p style={{ color: '#fff' }}>Versão 0.10</p>
          </Col>
        </Row>
      </Footer>
    </Layout>

  );
}


const mapState = (state) => ({
  usuario: state.usuario.usuario,
  tabsFiliais: state.nf.tabsFiliais,

})
const mapDispatch = (dispatch) => ({
  LimparTabs: dispatch.nf.LimparTabs,
  definirUsuario: dispatch.usuario.definirUsuario,
})

export default connect(mapState, mapDispatch)(LayoutDetail)
